<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">edit</i>
                        </div>
                        <h4 class="card-title ">Editar</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.status != '', 'has-danger' : validation.status != '' }">
                                        <label for="status" class="bmd-label-floating">Status *</label>
                                        <input refs="status" type="text" class="form-control" v-model="form.status" />
                                        <label v-if="validation.status != ''" id="status-error" class="error" for="status">{{ validation.status }}</label>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group">
                                        <b-form-checkbox style="padding-left: 0; padding-top: 1rem;"
                                            v-model="form.finish_after_sale"
                                            >
                                            {{ 'Finalizar o pós venda?' }}
                                        </b-form-checkbox>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group">
                                        <b-form-checkbox style="padding-left: 0; padding-top: 1rem;"
                                            v-model="form.must_transfer_formalization"
                                            >
                                            {{ 'Deve transferir o pós venda?' }}
                                        </b-form-checkbox>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group">
                                        <b-form-checkbox style="padding-left: 0; padding-top: 1rem;"
                                            v-model="form.auto_finish"
                                            >
                                            {{ 'Finalizar automaticamente?' }}
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons 
                                v-bind:to-back="{name: 'after-sale-status.index'}"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>    
    export default {
        computed: {
            form() {
                return this.$store.state.after_sale_status.item;
            }
        },
        created() {
            this.getData();
        },
        data() {
            return {
                validation: {
                    status: ''
                }
            };
        },
        methods: {
            onSubmit(_ev) {
                var valid = true;
                var self = this;

                self.validation.status = '';

                if (self.form.status == '') {
                    self.validation.status = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit('onLoading');
                    
                    const response = self.$store.dispatch('after_sale_status/edit', this.form);

                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Status de pós venda atualizado com sucesso!");
                        self.$router.push({'name': 'after-sale-status.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');
                        if (err.status === 422) {
                            if (err.data.errors.status !== undefined) {
                                self.validation.status = err.data.errors.status[0];
                            }
                        }
                    });
                }
                
                _ev.preventDefault();
            },
            async getData() {
                var self = this;
                
                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('after_sale_status/get', this.$route.params.id);
                
                response.then(function(){
                    self.$root.$emit('onLoading');
                });
                
                response.catch(function(){
                    self.$root.$emit('onLoading');
                    self.$router.push({'name': 'after-sale-status.index'});
                });
            }
        }
    };
</script>